import React from "react";
import { Flex, Box } from "grid-styled";
import { Panel, PanelBody } from "../Panel";
import Link from "../Link";
import { downloadReport } from "../../api";

const AnchorLink = Link.withComponent("a");

const ReportCard = ({ children }) => (
  <Box w={[1 / 3]} px={2} pb={3}>
    <Panel>
      <PanelBody>{children}</PanelBody>
    </Panel>
  </Box>
);

const handleCSVDownload = () => {
  downloadReport("chatmeter", { filename: "Reputation Loop" });
};

const Reports = () => (
  <Flex p={3} mx={-2} wrap>
    <ReportCard>
      <Link to="/admin/reports/daily-sales">Daily Sales</Link>
    </ReportCard>
    <ReportCard>
      <Link to="/admin/reports/monthly-sales-by-franchise">
        Monthly Sales By Franchise
      </Link>
    </ReportCard>
    <ReportCard>
      <Link to="/admin/reports/sales-by-salesperson">Sales by Salesperson</Link>
    </ReportCard>
    <ReportCard>
      <Link to="/admin/reports/cancelled">Cancelled</Link>
    </ReportCard>
    <ReportCard>
      <AnchorLink onClick={handleCSVDownload}>
        Reputation Loop (as CSV)
      </AnchorLink>
    </ReportCard>
  </Flex>
);

export default Reports;



// WEBPACK FOOTER //
// ./src/components/admin/Reports.js